module.exports = __webpack_public_path__ + "img/inject-banner.6988ee80.png";